import axios from 'axios'
import { config } from '@/shared/app.config'

const RESOURCE_NAME = '/journeyday'

export default {
  create(data) {
    return axios.post(`${config.webApiBase}${RESOURCE_NAME}`, data)
  },

  getCurrent() {
    return axios.get(`${config.webApiBase}${RESOURCE_NAME}/current`)
  },

  complete(data) {
    return axios.post(`${config.webApiBase}${RESOURCE_NAME}/complete`, data)
  },

  getUserSchedules() {
    return axios.get(`${config.webApiBase}${RESOURCE_NAME}/user-schedules`)
  },
}
